import { useShippingRateAction } from '../hooks/useCheckoutAction'
import { ActionProgress, Icon } from '@ztechapps/webui.util'
import { OrderCheckoutActivePanelEnum } from '@ztechapps/order.common'
import React from 'react'

export const ShippingRateActionProgressStep = () => {
  //const { onClickShippingRate } = useCheckoutAction()
  const [onClickShippingRate] = useShippingRateAction()

  return (
    <ActionProgress.Step stepKey={OrderCheckoutActivePanelEnum.shippingRate} onClick={onClickShippingRate}>
      <Icon name="money-check-dollar" /> Shipping Rate
    </ActionProgress.Step>
  )
}
